import { storageHelper, User } from '@spo/logic';
import { ComponentType } from 'react';
import { useLocation } from 'react-router-dom';
import { useAmplitudePageViewed } from '../../hooks/amplitude/useAmplitudePageViewed';
import { useParameters } from '../../hooks/useParameters';
import { MaintenancePage } from '../maintenance';

export const AuthenticatedApp = ({
  Component,
}: {
  Component: ComponentType;
}) => {
  const { pathname } = useLocation();
  useAmplitudePageViewed(pathname);

  const currentUser = storageHelper.getItem<User>('user');

  const { data: isUnderMaintenance } = useParameters({
    parameterName: 'UNDER_MAINTENANCE',
    uid: currentUser?.uid || '',
  });

  return isUnderMaintenance === true ? <MaintenancePage /> : <Component />;
};

export default AuthenticatedApp;
